<div class="space-y-1">
  <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>

  <p class="text-sm text-gray-900 flex items-center">
    {{ description }}
    @if (icons.length) {
      @for (i of icons; track i) {
        <span
          class="ml-4 inline-flex items-center justify-center w-5 h-5 rounded-full bg-cyan-800 text-white text-xs cursor-pointer"
          [pTooltip]="i.tooltip"
          [style]="i.style">
          <i
            [class]="i.icon"
            style="color: white; font-size: 0.6rem"></i>
        </span>
      }
    }
  </p>
  @if (subtitle) {
    <div>
      <desy-details summaryText="Ver descripción">{{ subtitle }}</desy-details>
    </div>
  }
  <div>
    @if (linkReference) {
      <a
        href="#"
        class="text-sm text-sky-700 hover:underline">
        {{ linkText }}
      </a>
    }
    @if (action) {
      <a
        role="button"
        (click)="action()"
        class="text-sm text-sky-700 hover:underline">
        {{ linkText }}
      </a>
    }

    @if (externalLink) {
      <a
        [href]="externalLink"
        target="_blank"
        class="text-sm text-sky-700 hover:underline ml-4">
        Ver detalles
      </a>
      <i
        class="pi pi-external-link ml-2"
        style="color: blue; font-size: 0.6rem"></i>
    }
  </div>
</div>
